import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { label, current, previous } = payload[0].payload;
  const diff = current - previous;
  const diffText =
    diff === 0
      ? 'Sin diferencia'
      : diff > 0
      ? `📈 +${formatMoney(diff)} más que la semana pasada`
      : `📉 ${formatMoney(Math.abs(diff))} menos que la semana pasada`;

  return (
    <Box bgcolor="white" p={1.5} borderRadius={1} boxShadow={2}>
      <Typography variant="subtitle2">📅 Día: {label}</Typography>
      <Typography variant="body2" color="#1976d2">Actual: {formatMoney(current)}</Typography>
      <Typography variant="body2" color="#ef5350">Semana pasada: {formatMoney(previous)}</Typography>
      <Typography variant="caption">{diffText}</Typography>
    </Box>
  );
};

const SalesComparisonChart = ({ data = [], loading }) => {
  return (
    <Paper elevation={2} sx={{ p: 2, height: 360 }}>
      <Typography variant="subtitle1" gutterBottom>
        Comparativa de ventas (semana actual vs semana pasada)
      </Typography>
      <Box sx={{ width: '100%', height: 300 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={300} />
        ) : data.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 20, right: 30, bottom: 0, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="label" />
              <YAxis domain={[0, 'dataMax + 500']} />
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              <Line
                type="monotone"
                dataKey="current"
                name="Semana actual"
                stroke="#1976d2"
                strokeWidth={2}
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="previous"
                name="Semana pasada"
                stroke="#ef5350"
                strokeWidth={2}
                strokeDasharray="5 5"
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default SalesComparisonChart;
